var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Stack } from '@mui/material';
import { GridActionsCellItem } from '@mui/x-data-grid-premium';
import { DynamicCatalogBuilder } from '../../../../builderPackage/components/dynamicCatalogBuilder/dynamicCatalogBuilder';
import { CloseAFRPopup } from './closeAFRpopup';
import { showSurface } from '../../../../redux/awaitedSurfacesSlice';
import { useAppDispatch } from '../../../../store/hooks';
import { ResendToASMPopup } from './resendToASMPopup';
import { useNavigate } from 'react-router-dom';
var AFRsCatalog = function (props) {
    var dispatch = useAppDispatch();
    var navigate = useNavigate();
    var value = props.value;
    var CTAs = [{
            Name: 'ResendToASM',
            DisplayName: 'Resend to ASM'
        }, {
            Name: 'Close AFR',
            DisplayName: 'Close AFR'
        }, {
            Name: 'Edit',
            DisplayName: 'Edit'
        }, {
            Name: 'View',
            DisplayName: 'View'
        }, {
            Name: 'Print',
            DisplayName: 'Print'
        }, {
            Name: 'Download PDF',
            DisplayName: 'Download PDF'
        }, {
            Name: 'Share',
            DisplayName: 'Share'
        }];
    var customActionColumns = [{
            field: 'Documentno.',
            headerName: 'Document no.',
            align: 'center',
            headerAlign: 'center',
            minWidth: 170
        }, {
            field: 'Documentdate',
            headerName: 'Document date',
            align: 'center',
            headerAlign: 'center',
            minWidth: 150
        }, {
            field: 'Submissiondate',
            headerName: 'Submission date',
            align: 'center',
            headerAlign: 'center',
            minWidth: 150
        }, {
            field: 'Group name & code',
            headerName: 'Group name & code',
            align: 'center',
            headerAlign: 'center',
            minWidth: 170
        }, {
            field: 'Defect description & code',
            headerName: 'Defect description & code',
            align: 'center',
            headerAlign: 'center',
            minWidth: 210
        }, {
            field: 'Part name & code',
            headerName: 'Part name & code',
            align: 'center',
            headerAlign: 'center',
            minWidth: 180
        }, {
            field: 'Model name, family & code',
            headerName: 'Model name, family & code',
            align: 'center',
            headerAlign: 'center',
            minWidth: 220
        }, {
            field: 'Woner',
            headerName: 'Woner',
            align: 'center',
            headerAlign: 'center',
            minWidth: 120
        }, {
            field: 'Category',
            headerName: 'Category',
            align: 'center',
            headerAlign: 'center',
            minWidth: 120
        }, {
            field: 'Assigned by',
            headerName: 'Assigned by',
            align: 'center',
            headerAlign: 'center',
            minWidth: 130
        }, {
            field: 'Intensity',
            headerName: 'Intensity',
            align: 'center',
            headerAlign: 'center',
            minWidth: 130
        }, {
            field: 'Ageing',
            headerName: 'Ageing',
            align: 'center',
            headerAlign: 'center',
            minWidth: 130
        }, {
            field: 'PSG remarks',
            headerName: 'PSG remarks',
            align: 'center',
            headerAlign: 'center',
            minWidth: 200
        }, {
            field: 'Status',
            headerName: 'Status',
            align: 'center',
            headerAlign: 'center',
            minWidth: 200
        }, {
            type: 'actions',
            field: 'actions',
            headerName: '',
            getActions: function (params) {
                var _this = this;
                return CTAs.map(function (data) { /*#__PURE__*/ return React.createElement(GridActionsCellItem, {
                    label: data.DisplayName,
                    showInMenu: true,
                    onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                        var res, res;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    console.log('data.name', data === null || data === void 0 ? void 0 : data.Name);
                                    if (!((data === null || data === void 0 ? void 0 : data.Name) === 'Close AFR')) return [3 /*break*/, 2];
                                    return [4 /*yield*/, dispatch(showSurface({
                                            type: 'Dialog',
                                            Component: CloseAFRPopup,
                                            containerProps: {
                                                maxWidth: 'xs'
                                            },
                                            componentProps: {
                                                isAFR: true,
                                                subtitle: 'Actions taken cannot be undone.',
                                                remarkTitle: 'PSG remarks'
                                            }
                                        }))];
                                case 1:
                                    res = _a.sent();
                                    return [3 /*break*/, 5];
                                case 2:
                                    if (!((data === null || data === void 0 ? void 0 : data.Name) === 'ResendToASM')) return [3 /*break*/, 4];
                                    return [4 /*yield*/, dispatch(showSurface({
                                            type: 'Dialog',
                                            Component: ResendToASMPopup,
                                            containerProps: {
                                                maxWidth: 'sm'
                                            }
                                        }))];
                                case 3:
                                    res = _a.sent();
                                    return [3 /*break*/, 5];
                                case 4:
                                    if ((data === null || data === void 0 ? void 0 : data.Name) == 'Edit') {
                                        navigate('/receivedAFRs/editAFR');
                                    }
                                    _a.label = 5;
                                case 5: return [2 /*return*/];
                            }
                        });
                    }); }
                }); });
            }
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Stack, {
        p: 2
    }, /*#__PURE__*/ React.createElement(DynamicCatalogBuilder, {
        columns: customActionColumns,
        rows: [{
                id: 0
            }, {
                id: 1
            }],
        dataGridProps: {
            disableColumnMenu: false
        }
    })));
};
export default AFRsCatalog;
